import React from "react";
import { StyledEngineProvider } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import reduxStore from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import Router from "./router";
import ReactNotifications from "react-notifications-component";
import { SWRConfig } from "swr";
import { fetcher } from "api";

import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

const { store, persistor } = reduxStore();

const theme = createTheme({
  palette: {
    primary: {
      main: "#00BDF2",
      contrastText: "#fff",
    },
    secondary: {
      main: "#4DB85C",
      contrastText: "#fff",
    },
    lightBlue: {
      main: "#F3F9FC",
      contrastText: "#333E48",
    },
    darkGrey: {
      main: "#333E48",
      contrastText: "#FFF",
    },
    grey: {
      main: "#919191",
      contrastText: "#FFF",
    },
    error: {
      main: "#cc0000",
      contrastText: "#FFF",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    h1: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: "500",
      fontSize: "1.5em",
    },
    h4: {
      fontFamily: "Roboto, sans-serif",
    },
    h5: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: "500",
    },
    h6: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: "500",
    },
    body1: {
      fontFamily: "Roboto, sans-serif",
    },
    body2: {
      fontFamily: "Roboto, sans-serif",
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        fontFamily: "Roboto, sans-serif",
      },
    },
    MuiButton: {
      text: {
        fontFamily: "Roboto, sans-serif",
        fontWeight: "500",
        fontSize: "1.2em",
      },
      contained: {
        fontFamily: "Roboto, sans-serif",
        fontWeight: "500",
        fontSize: "1.2em",
      },
      containedSizeSmall: {
        fontSize: "1.1em",
      },
    },
    MuiTab: {
      textColorPrimary: {
        fontFamily: "Roboto, sans-serif",
      },
    },
  },
});

export const muiCache = createCache({
  key: "mui",
  prepend: true,
});

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* <StyledEngineProvider injectFirst> */}
        <CacheProvider value={muiCache}>
          <ThemeProvider theme={theme}>
            <BrowserRouter>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SWRConfig value={{ fetcher }}>
                  <ReactNotifications />
                  <Router />
                </SWRConfig>
              </LocalizationProvider>
            </BrowserRouter>
          </ThemeProvider>
        </CacheProvider>
        {/* </StyledEngineProvider> */}
      </PersistGate>
    </Provider>
  );
}

export default App;
